import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle, ChevronRight } from 'lucide-react';

export const UrgentJobBanner = () => {
  return (
    <Link
      to="/recrutement"
      className="group block mx-4 sm:mx-auto max-w-5xl mt-6"
      data-testid="urgent-job-banner"
    >
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-red-600 via-red-500 to-orange-500 shadow-2xl ring-2 ring-red-300/60 hover:ring-red-400 transition-all duration-300 hover:scale-[1.01]">
        {/* Flashing dot layer */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_50%,rgba(255,255,255,0.15),transparent_40%)] pointer-events-none" aria-hidden="true"></div>

        <div className="relative flex items-center gap-3 sm:gap-5 px-4 sm:px-6 py-4">
          {/* Blinking dot */}
          <div className="relative flex-shrink-0">
            <span className="absolute inline-flex h-4 w-4 rounded-full bg-white opacity-75 animate-ping"></span>
            <span className="relative inline-flex rounded-full h-4 w-4 bg-white"></span>
          </div>

          <AlertCircle className="h-6 w-6 sm:h-7 sm:w-7 text-white flex-shrink-0 animate-pulse" />

          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="bg-white text-red-600 px-2 py-0.5 rounded text-xs font-black uppercase tracking-wider">
                URGENT
              </span>
              <span className="text-white font-black text-base sm:text-lg uppercase tracking-wide">
                Poste à pourvoir immédiatement
              </span>
            </div>
            <p className="text-red-50 text-xs sm:text-sm mt-0.5 font-medium">
              Nous recrutons ! Expérience pressing obligatoire. <span className="hidden sm:inline">Temps plein 35h. </span>Cliquez pour postuler.
            </p>
          </div>

          <ChevronRight className="h-6 w-6 sm:h-8 sm:w-8 text-white flex-shrink-0 group-hover:translate-x-1 transition-transform duration-300" />
        </div>
      </div>
    </Link>
  );
};
